import { PageControl } from './main';
import { SimpleLocationModel } from 'app/restricted/suppliers/supplier-single-solution/supplier-single-solution.component';
import { Params } from '@angular/router';

export class Solution {
    description: string;
    imageUrls: Array<string>;
    solutioName: string;
    solutionId: string;
    solutionName: string;
    supplierId: string;
    supplierName: string;
    supplierImageUrl: string;

    // Single
    areaIds: Array<any>;
    availablePlaces: Array<string> = [];
    availableWorldwide: boolean;
    categories: Array<any>;
    ceilingCostValue: number;
    city: string;
    compliedIndicatorIds: Array<string> = []
    cost: number;
    costValue: number;
    deliveryTime: number;
    documents: Array<any> = [];
    documentUrls: Array<string> = [];
    firaId: number;
    floorCostValue: number;
    groupName: string;
    imageVideos: Array<any> = [];
    impact: number;
    implementedCities: any[] = []
    implementedCityIds: Array<string> = []
    indicators: SolutionIndicatorScore[] = [];
    isTranslated?: boolean;
    translated?: boolean;
    name: string;
    nameCompany: string;
    preRequisites: string;
    price: string;
    region: string;
    relatedSolution: Array<Solution> = [];
    results: string;
    solutionCategory: Array<string> = []
    status: number;
    supplierImage: any;
    tags: any;
    time: number;
    timeValue: number;
    verified: boolean;
    website: string;
    whatItIs: string;
}

export class SolutionsSearchParams {
    cost: number[] = [];
    estimatedInvestment: string[] = [];
    featuredIn: string[] = [];
    impact: number[] = [];
    location: string[] = [];
    population: string[] = [];
    search: string;
    statusSolution: string;
    supplierId: string;
    tags: string[] = [];
    technology: string[] = [];
    time: number[] = [];
    pageControl: PageControl = new PageControl;
}

export class SolutionModel {
    id: string = '';
    areaIds: Array<string> = []
    availablePlaces: Array<string> = []
    availableWorldwide: boolean;
    compliedIndicatorIds: Array<string> = []
    cost: number;
    costValue: number;
    deliveryTime: string;
    description: string = '';
    firaId: number;
    imageUrls: any = [];
    implementedCities: any[] = []
    implementedCityIds: Array<string> = []
    indicators: SolutionIndicatorScore[] = [];
    name: string = '';
    preRequisites: string = '';
    price: number;
    results: string = '';
    solutionId: string = '';
    solutionCategory: Array<string> = []
    supplierId: string = '';
    tags: Array<string> = []
    time: number;
    timeValue: number;
    website: string;
    whatItIs: string;

    imageVideos: Array<any> = [];
    documentUrls: Array<string> = [];

    constructor() {
        this.imageUrls = [];
    }
}

export class SolutionIndicatorScore {
    indicatorId: string;
    cost: number;
    estimatedDifference: number;
    impact: number;
    score: number;
    time: number;
}

export class TypesOnSolutionHelper {
    solutionCategories: string[] = [];
    solutionDeliveryTimes: string[] = [];
}

export class SolutionCostTimeHelper {
    cost: number;
    time: number;
}

export class HighlightedSolution {
    areaIds: string[];
    areasIcons: string[];
    description: string;
    imageUrls: string[];
    solutionId: string;
    solutionName: string;
}